import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0084FF',
      dark: '#0073DF',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#02066E',
      light: '#84FF0A0D',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F8FBFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#040747',
      secondary: '#686A90',
    },
    divider: '#E0EAF3',
    error: {
      main: '#BA1A1A',
      light: '#FFDAD6',
      dark: '#410002',
    },
    info: {
      main: '#686A90',
      light: '#0073DF',
      contrastText: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    titleLarge: {
      fontWeight: 600,
      fontSize: '18px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {

          '&.MuiChip-colorInfo': {
            backgroundColor: '#F2F9FF',
            color: '#02066E',
          },
        },
      },
    },
  },
});

// Add custom theme typings
declare module '@mui/material/styles' {
  interface TypographyVariants {
    titleLarge: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    titleLarge?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    titleLarge: true;
  }
} 